import React, { useState } from 'react'
import { Button, Table, Upload, message } from 'antd'
import { DownloadOutlined, ImportOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import { useLocalization } from '@contexts/LocalizationContext'
import PageLayout from '@layouts/PageLayout'
import { ExcelToJSON } from '@utils/excel'
import { client } from '@utils/client'

const Create = () => {
  const history = useHistory()
  const { t } = useLocalization()
  const [payload, setPayload] = useState([])

  const actions = {
    setPayload,
  }
  const customRequest = ({ file, onSuccess }) => {
    const xl2json = new ExcelToJSON(actions)
    xl2json.parseExcel(file)
    setTimeout(() => {
      onSuccess('ok')
    }, 0)
  }

  const handleSubmit = async () => {
    if (payload.length === 0) {
      message.warn('กรุณาอัปโหลดข้อมูลก่อน')
      return
    }
    try {
      const data = payload.map((item) => ({
        type: 'development',
        ...item,
      }))
      await client.post('/checklist', data)
      message.success('สำเร็จ')
      history.push('/development')
    } catch (e) {
      message.error('ไม่สำเร็จ')
    }
  }

  const columns = [
    {
      title: t('development.listScreen.column.title'),
      dataIndex: 'title',
      key: 'title',
      width: '10%',
    },
    {
      title: t('development.listScreen.column.description'),
      dataIndex: 'description',
      key: 'description',
      width: '15%',
    },
    {
      title: t('development.listScreen.column.detail'),
      dataIndex: 'detail',
      key: 'detail',
      width: '15%',
    },
    {
      title: t('development.listScreen.column.titleEn'),
      dataIndex: 'titleEn',
      key: 'titleEn',
      width: '10%',
    },
    {
      title: t('development.listScreen.column.descriptionEn'),
      dataIndex: 'descriptionEn',
      key: 'descriptionEn',
      width: '15%',
    },
    {
      title: t('development.listScreen.column.detailEn'),
      dataIndex: 'detailEn',
      key: 'detailEn',
      width: '15%',
    },
    {
      title: t('development.listScreen.column.from'),
      dataIndex: 'from',
      key: 'from',
      width: '5%',
    },
    {
      title: t('development.listScreen.column.to'),
      dataIndex: 'to',
      key: 'to',
      width: '5%',
    },
    {
      title: t('development.listScreen.column.priority'),
      dataIndex: 'priority',
      key: 'priority',
      width: '5%',
    },
    {
      title: t('development.listScreen.column.alertMo'),
      dataIndex: 'alertMo',
      key: 'alertMo',
      width: '5%',
    },
  ]

  const data = payload

  return (
    <PageLayout
      title={t('development.createScreen.title')}
      extra={[
        <div key="extra" style={{ display: 'flex' }}>
          <Button
            key="download"
            type="link"
            href={`${process.env.PUBLIC_URL}/assets/checklist-template.xlsx`}
            icon={<DownloadOutlined />}
          >
            {t('development.createScreen.downloadTemplate')}
          </Button>
          <Upload accept=".xlsx" customRequest={customRequest}>
            <Button icon={<ImportOutlined />} style={{ margin: '0 10px' }}>
              {t('development.createScreen.uploadExcel')}
            </Button>
          </Upload>
          <Button key="submit" type="primary" onClick={handleSubmit}>
            {t('development.createScreen.submit')}
          </Button>
        </div>,
      ]}
    >
      <Table columns={columns} dataSource={data} />
    </PageLayout>
  )
}

export default Create
